import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Select } from 'components'
import styles from './index.module.css'

const CareerIncomeDetails2 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<Select title="월별 납부내역 보기" className="bold auto" style={{ borderBottom: 0, height: "3rem", lineHeight: "3rem" }} selected={1} data={[
						{ key: "2022년 1월", value: 0 },
						{ key: "2022년 2월", value: 1 },
						{ key: "2022년 3월", value: 2 },
					]} onSelect={(key, value) => {
						console.log(key, value)
					}}>
					</Select>
					<div className={`${styles["l-title"]} mt_15`}>보험료 납부금액</div>
					<div className={`${styles["price-lg"]} mt_10`}><strong>501,000</strong> 원</div>
					<div className="date-progress mt_40 pb_30">
						<div className="date">
							<span>0원</span>
							<span>601,000 원</span>
						</div>
						<div className="progress mt_10">
							<span style={{ width: "70%" }} />
						</div>
						<span className="date-guide bubble center" style={{ left: "59%" }}>70% 납부</span>
					</div>
				</div>
			</div>
			<p className={`${styles["tag-txt"]} mt_10 padding pb_10`}>#직장가입자</p>
			<div className="no-scroll" style={{ overflowX: "auto" }}>
				<ul className="tab-round no-wrap">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>주식회사 핀테크</li>
				</ul>
			</div>
			<div className="padding pt_20">
				<div className={styles["result-title"]}>
					소득월액(장기요양보험) <strong style={{ color: "#333" }}>100,000원</strong>이며<br />
					현재 <strong>10%</strong> 납부되었네요!
				</div>
				<ul className={`${styles["bar-horizontal"]} mt_40`}>
					<li>
						<div className={styles.title}><strong>건강보험</strong></div>
						<div className={styles["bar-area"]}>
							<div className={styles.bar}>
								<span style={{ width: "100%" }}>
									<span className={styles.percent}>100%</span>
								</span>
							</div>
							<span>301,000원 납부</span>
						</div>
					</li>
					<li>
						<div className={styles.title}>장기요양보험</div>
						<div className={styles["bar-area"]}>
							<div className={styles.bar}>
								<span style={{ width: "100%" }}>
									<span className={styles.percent}>100%</span>
								</span>
							</div>
							<span>400,000원 납부</span>
						</div>
					</li>
					<li>
						<div className={styles.title}>소득월액<p>(건강보험)</p></div>
						<div className={styles["bar-area"]}>
							<div className={styles.bar}>
								<span style={{ width: "70%" }}>
									<span className={styles.percent}>70%</span>
								</span>
							</div>
							<span>200,000원 납부</span>
						</div>
					</li>
					<li>
						<div className={`${styles.title} text-blue`}>소득월액<p>(장기요양보험)</p></div>
						<div className={styles["bar-area"]}>
							<div className={styles.bar}>
								<span style={{ width: "10%", background: "var(--main-color)" }}>
									<span className={styles.percent} style={{ left: "100%", color: "var(--main-color)", marginLeft: "1rem" }}>10%</span>
								</span>
							</div>
							<span>200,000원 납부</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default CareerIncomeDetails2
